import './ConfirmBookingModal.css';
import { DateFormat } from '../../utils/DateFormat';
import ModalPortal from '../modal/ModalPortal';

type Props = {
  dateFrom: string;
  dateTo: string;
  submitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmBookingModal = ({
  dateFrom,
  dateTo,
  submitting = false,
  onClose,
  onConfirm,
}: Props) => {
  const period =
    dateFrom === dateTo
      ? DateFormat(dateFrom)
      : `${DateFormat(dateFrom)} → ${DateFormat(dateTo)}`;

  return (
    <ModalPortal>
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Подтверждение брони</h3>
        <div className="modal-body">
          <label>Период</label>
          <p>{period}</p>
          <p style={{ background: 'transparent', padding: 0, color: '#7f8c8d', fontSize: 13 }}>
            Бронь будет создана по дням. Дни вашей приоритетной недели одобрятся сразу,
            остальные — после решения владельца недели.
          </p>
        </div>
        <div className="modal-actions">
          <button type="button" className="btn-cancel" onClick={onClose} disabled={submitting}>
            Отмена
          </button>
          <button type="button" className="btn-save" onClick={onConfirm} disabled={submitting}>
            {submitting ? 'Бронирование...' : 'Подтвердить'}
          </button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default ConfirmBookingModal;
